import { SvgIcon, type SvgIconProps } from './svgIcon'

type Props = SvgIconProps & {
  fillColor?: string
  strokeColor?: string
}

export function AffiliateIcon({ width = 22, height = 18, ...props }: Props) {
  return (
    <SvgIcon
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      {...props}>
      <path
        d="M15.03 7.56C15.05 7.75 15.05 7.94 15.05 8.13C15.05 11.88 12.01 14.92 8.26001 14.92C4.51001 14.92 1.47 11.88 1.47 8.13C1.47 4.38 4.51001 1.34 8.26001 1.34C9.75001 1.34 11.13 1.82 12.26 2.64M18.38 4.28C18.38 6.09149 16.9115 7.56 15.1 7.56C13.2885 7.56 11.82 6.09149 11.82 4.28C11.82 2.46851 13.2885 1 15.1 1C16.9115 1 18.38 2.46851 18.38 4.28ZM20.99 14.22C20.99 15.4682 19.9782 16.48 18.73 16.48C17.4818 16.48 16.47 15.4682 16.47 14.22C16.47 12.9718 17.4818 11.96 18.73 11.96C19.9782 11.96 20.99 12.9718 20.99 14.22Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </SvgIcon>
  )
}
